import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class BankTemplateGetEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.bankTemplate.getApi),
			switchMap((action) =>
				this.vendorService.bankTemplate(action.country, action.currency).pipe(
					map((template) => VendorActions.bankTemplate.getSuccess(template)),
					catchError((error) =>
						of(VendorActions.bankTemplate.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService
	) {}
}
